<template>
  <header class="emh-ui-newsletter-header">
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: 'NewsletterHeader',
};
</script>

<style lang="scss" scoped>
.emh-ui-newsletter-header {
  @include wb-type-heading-xs;
  @include wb-spacing('margin-bottom', 'xxs');

  color: var(--ui-newsletter-header, var(--wb-black));
}
</style>
